var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAllImgVideo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_414",
    "data-name": "Rectangle 414",
    width: 24,
    height: 24,
    transform: "translate(24 24) rotate(180)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "all_1",
    "data-name": "all 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1556",
    "data-name": "Path 1556",
    d: "M2.488,23.889H21.4A2.491,2.491,0,0,0,23.889,21.4V2.488A2.491,2.491,0,0,0,21.4,0H2.488A2.491,2.491,0,0,0,0,2.488V21.4A2.491,2.491,0,0,0,2.488,23.889Zm-.5-2.488V12.94h8.958V21.9H2.488A.5.5,0,0,1,1.991,21.4Zm19.409.5H12.94V12.94H21.9V21.4A.5.5,0,0,1,21.4,21.9Zm.5-19.41v8.461H12.94V1.991H21.4A.5.5,0,0,1,21.9,2.488Zm-19.41-.5h8.461v8.958H1.991V2.488A.5.5,0,0,1,2.488,1.991Z",
    fill: "#c19444"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllImgVideo);
export default __webpack_public_path__ + "static/media/all-img-video.7060b03efa1a7827b58f97f1dae129e6.svg";
export { ForwardRef as ReactComponent };